import { render, staticRenderFns } from "./Vipbirthday.vue?vue&type=template&id=78822972&scoped=true&"
import script from "./Vipbirthday.vue?vue&type=script&lang=js&"
export * from "./Vipbirthday.vue?vue&type=script&lang=js&"
import style0 from "./Vipbirthday.vue?vue&type=style&index=0&id=78822972&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78822972",
  null
  
)

export default component.exports